<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title"> Kế hoạch bảo trì định kỳ</div>
      </div>
      <div class="card card-w-title">
        <div class="import-data download-data" v-if="$myConstants.checkRoleGroup('maintenance', 'download')">
          <button class="download-file" @click="exportDataExcel" >
            <i class="pi pi-download"></i>Xuất dữ liệu
          </button>
          <span >(Danh sách lịch bảo trì được tải về theo điều kiện lọc đã nhập)</span>
        </div>
        <div class="list-data" v-if="$myConstants.checkRoleGroup('maintenance', 'list')">
          <div class="list-title">
            <span class="p-m-0">Danh sách kế hoạch bảo trì định kỳ</span>
            <span class="p-input-icon-left" v-if="$myConstants.checkRoleGroup('maintenance', 'update_status')">
              <Button
              :style="(disable_update) ? 'background-color: rgba(153, 153, 153, 1);border: 1px solid #c8c9c9;':''"
              :disabled="disable_update"
              :label="'Cập nhật'"
              type="button"
              v-on:click="update_assignment()"
              > </Button>
            </span>
          </div>
          <BaseCommon v-if="dataModel"
            :classDatatable="'list_maintenance'"
            :key="componentKey"
            :listData="listData"
            :model="dataModel"
            :filterDefault="filters"
            :dateTypeDateFilterDefault="dateTypeDateFilterDefault"
            @filter="filterData"
            v-on:action-click="onActionClicked"
            :actions="getRowActions()"
            @callback="callbackListData"
            @clearFilter="cancelFilter"
          ></BaseCommon>
        </div>
      </div>
    </div>
    <Dialog
        class="dialog-comfirm-common"
        :visible.sync="showConfirmDialog"
        :contentStyle="{overflow: 'visible'}"
        :modal="true"
        :closable="true"
    >
      <div class="box_body_popup" >
        <div v-if="creenConfirmDialog == 'export_success'">
          <div class="box_title_suceess"><img class="img_noti" :src="check_success_img" /><span class="title_noti" style="">Thành công</span></div>
          <p class="p_title_1" style="text-align: left"><span style="font-weight: 700">Kế hoạch bảo trì định kỳ</span> đã xuất dữ liệu thành công. Vui lòng thực hiện tải về tại module Lịch sử xuất dữ liệu.</p>
          <div class="box_btn">
            <Button
                icon="pi pi-chevron-circle-right"
                iconPos="right"
                class="btn-custom"
                :label="'Lịch sử xuất dữ liệu'"
                type="button"
                @click="redirect_ToHistory"
            > </Button>
          </div>
        </div>
        <div v-if="creenConfirmDialog == 'export_err'">
          <div class="box_title_err"><img class="img_noti" :src="err_massage_img" /><span class="title_noti" style="">Thất bại</span></div>
          <p class="p_title_1" style="text-align: left">Quá trình xuất dữ liệu <span style="font-weight: 700;">Kế hoạch bảo trì định kỳ</span> đã xảy ra vấn đề. Bạn vui lòng thực hiện lại thao tác xuất dữ liệu.</p>
        </div>
      </div>
      <template #header>
        <div>
          <span class="title-confirm" >Thông báo</span>
          <!--<span class="description-confirm">asdasdas</span>-->
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseCommon from '../common'
import moment from "moment";
export default {
  components: {
    BaseCommon
  },
  data() {
    return {
      filters: {},
      listData: [],
      dataModel: null,
      componentKey: 0,
      disable_update:true,
      listDataExport:[],
      showConfirmDialog:false,
      creenConfirmDialog:'export_success',
      check_success_img: window.origin + '/assets/images/check_success.png',
      err_massage_img: window.origin + '/assets/images/err_massage.png',
      dateTypeDateFilterDefault:null,
      userID : null,
    }
  },
  mounted () {
    this.initData();
    if(this.$store.getters.fullname !== undefined && this.$store.getters.fullname !== null){
      if(this.$store.getters.fullname.id !== undefined && this.$store.getters.fullname.id !== null && this.$store.getters.fullname.id !== ''){
        this.userID = this.$store.getters.fullname.id
      }
    }
  },
  created () {
    if(this.$route.params.reload) {
      window.location.reload();
    }
  },
  watch: {
    '$route': 'initData'
  },
  methods: {
    initData() {
      setTimeout(async () => {
        if (this.$myConstants.checkRoleGroup('maintenance', 'list')) {
          await this.initParams();
        }
      }, 1000);
    },
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    async initParams() {

      this.filters = {
        date_maintenance: {
          from:  new Date(moment().startOf('month').format('YYYY-MM-DD')),
          to: new Date(moment().endOf('month').format('YYYY-MM-DD'))
        },
        type_maintenance:0,
        is_assignment:false
      };
      this.dateTypeDateFilterDefault = 2;
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      //this.filters.address_info = "aa";
      this.modelName = 'maintenance';
      var variables = {
        where_key: {
          status: {'_in': [0, 1] }
        },
        orderBy: [
          {date_maintenance: 'desc'},
          {parts_number: 'desc'}
        ]
      }
      var array_sort_status = {
        0:1,
        1:0,
        2:2,
        3:4,
        4:4,
        5:5,
      };
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      var list_id_maintence = [];
      if (list.length > 0){
        for (var i=0;i<list.length;i++){
          list[i].sortProcessStatus = array_sort_status[list[i].process_status];
          list_id_maintence.push(list[i].id);
        }
      }
      var map_wr_product = {};
      if (list_id_maintence.length > 0){
        var variables_wr_product_serial_number = {
          where_key: {
            check_maintenance_period : {_in: list_id_maintence}
          },
          orderBy: {"id": "desc"}
        }
        var wr_product_serial_number = await DataServices.getList('warranty_repair_product_serial_number', {"variables": JSON.stringify(variables_wr_product_serial_number), "fields": "id check_maintenance_period"});
        var list_wr_product = wr_product_serial_number[Object.keys(wr_product_serial_number)];
        for (var w=0;w<list_wr_product.length;w++){
          map_wr_product[list_wr_product[w].check_maintenance_period] = list_wr_product[w];
        }
      }
      if (list.length > 0) {
        for (var j = 0; j < list.length; j++) {
          if (!this.$myConstants.isEmpty(map_wr_product[list[j].id])){
            list[j].id_wr_product = map_wr_product[list[j].id].id;
          }

        }
      }

      this.dataModel = DataServices.getModel(this.modelName);
      this.dataModel.processData(list);
      //list.sort((a,b)=> (a.process_status - b.process_status ||  b.id - a.id ));
      //sort từ dữ liệu trả về
      if (list.length > 0){
        list.sort((a,b)=> (a.sortProcessStatus - b.sortProcessStatus ||  new Date(b.date_maintenance) - new Date(a.date_maintenance) || b.parts_number - a.parts_number ));
      }
      this.listDataExport = list;
      this.listData = list;
      this.componentKey++;
      this.$store.commit('setLoading', false);
    },
    dang_phat_trien(){
      alert('Đang phát triển');
    },
    redirect_ToHistory(){
      this.$router.push({path: '/admin/history-export'});
    },
    async  filterData(payload){
      // console.log("assssssssss:",this.filters)
      this.listDataExport = payload.filteredValue;
    },
    async  exportDataExcel(){
    var list_id_maintence = [];
    if (this.listDataExport.length < 1){
      this.$toast.add({
        severity: 'error',
        summary: 'Thông báo',
        detail: 'Không tồn tại dữ liệu xuất',
        life: 3000
      });
      return false;
    }
    this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
    this.$store.commit('setLoading', true);
    for (var i=0;i<this.listDataExport.length;i++){
      list_id_maintence.push(this.listDataExport[i].id);
    }
      try {
        var dataResponse = await this.$coreService.callApiPost('/export_excel/list_maintence',{list_id_maintence:list_id_maintence,user_id : this.userID},{})
        var key_s3 = dataResponse.data.data.key_s3;
        var dataResponseDownload = await this.$coreService.callApiDownloadPost('/export_excel/read_file_export',{key_s3:key_s3},{})
        var url = URL.createObjectURL(new Blob([dataResponseDownload.data], {
          type: 'application/vnd.ms-excel'
        }))
        const link = document.createElement('a')
        link.href = url;
        var file_excel = 'DanhSachBaoTri_'+moment().tz("Asia/Bangkok").format('DDMMYYYY')+'_'+moment().tz("Asia/Bangkok").format('HHmmss')+'.xlsx';
        link.setAttribute('download', file_excel)
        document.body.appendChild(link)
        link.click()
        this.showConfirmDialog = true;
        this.creenConfirmDialog = 'export_success';

    } catch (err) {
        console.log("err:",err);
        this.showConfirmDialog = true;
        this.creenConfirmDialog = 'export_err';
      }
      this.$store.commit('setLoading', false);
    },
    callbackListData(col, payload) {
      //var vm = this;
      //console.log("5555555555");
      if (col.name == 'is_assignment') {
        this.disable_update = false;
        if (payload);
      }
    },
   async update_assignment(){
      if (this.disable_update == false){
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var list_id_update_false = [];
        var list_id_update_true = [];
        for (var i=0;i<this.listData.length;i++){
          if (this.listData[i].type_maintenance == 0){
            if (this.listData[i].is_assignment == true){
              list_id_update_true.push(this.listData[i].id);
            }else {
              list_id_update_false.push(this.listData[i].id);
            }
          }
        }
        var count_done = 0;
        var whereInfoTrue = { id: {_in: list_id_update_true} }
        DataServices.updateData('maintenance', {"variables": JSON.stringify({data_update: {is_assignment:  true}, where_key: whereInfoTrue})}).then(async () => {
          count_done++;
          if (count_done == 2){
            this.disable_update = true;
            this.update_assignment_success();
          }
        }).catch(async () => {
          count_done++;
          //báo lỗi 1 lần
          if (count_done == 1){
            this.disable_update = true;
            this.update_assignment_err();
          }
        });

          var whereInfoFalse = { id: {_in: list_id_update_false} }
          DataServices.updateData('maintenance', {"variables": JSON.stringify({data_update: {is_assignment:  false}, where_key: whereInfoFalse})}).then(async () => {
            count_done++;
            if (count_done == 2){
              this.disable_update = true;
              this.update_assignment_success();
            }
          }).catch(async () => {
            count_done++;
            if (count_done == 1){
              this.disable_update = true;
              this.update_assignment_err();
            }
          });
      }
    },
    update_assignment_success(){
      this.$store.commit('setLoading', false);
      this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 });
    },
    update_assignment_err(){
      this.$store.commit('setLoading', false);
      this.$toast.add({
        severity: 'error',
        summary: 'Thông báo',
        detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
        life: 3000
      });
    },
    onActionClicked(payload) {
      var action = payload.action
      /*var data = null
      if (payload.data) {
        data = payload.data
      }*/
      switch (action.name) {
        case 'add_warranty_repair':
          if(this.$myConstants.checkRoleGroup('warranty_repair', 'add')) {
            this.$router.push({path: action.path});
          }
          break;
        case 'view_warranty_repair_product':
          if(this.$myConstants.checkRoleGroup('warranty_repair', 'view')) {
              this.$router.push({path: action.path});
          }
          break;
      }
    },
    getRowActions() {
      var actions = {}
      var that = this;
      actions.filter = { name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
          var process_status = (!that.$myConstants.isEmpty(rowData.process_status)) ? rowData.process_status:null;
          var path = "";
          var modelaction;
          if (that.$myConstants.checkRoleGroup('warranty_repair', 'add')  && (process_status == that.$dataCommon.MAINTENANCE.PROCESS_STATUS.PLAN || process_status == that.$dataCommon.MAINTENANCE.PROCESS_STATUS.MAINTENANCE_NEEDED) ){
            path = "/admin/warranty-repair/function?id_maintenance="+rowData.id;
            buttons.edit = { name: 'add_warranty_repair', text: 'Tiếp nhận', isText: true,  key: 'id', path: path}
            if (that.dataModel.actions) {
               modelaction = that.dataModel.actions(rowData)
              Object.assign(buttons, modelaction);
            }
          }else if (that.$myConstants.checkRoleGroup('warranty_repair', 'view')  && (process_status == that.$dataCommon.MAINTENANCE.PROCESS_STATUS.PROCESSING || process_status == that.$dataCommon.MAINTENANCE.PROCESS_STATUS.FOR_MAINTENANCE) ){
            if (!that.$myConstants.isEmpty(rowData.id_wr_product)){
              var warranty_repair_product_serial_number_id = rowData.id_wr_product;
              path = "/admin/warranty-repair/view-detail/"+warranty_repair_product_serial_number_id;
              buttons.edit = { name: 'view_warranty_repair_product', text: 'Xem', isText: true,  key: 'id', path: path}
              if (that.dataModel.actions) {
                modelaction = that.dataModel.actions(rowData)
                Object.assign(buttons, modelaction);
              }
            }
          }
        return buttons
      }
      return actions
    },
    cancelFilter() {
      this.filters = {};
      // this.componentKey++;
      this.listDataExport = this.listData;
    }
  }
}
</script>
<style lang="scss">
.box-filters{ margin: 15px 0;
  .p-formgroup-inline { display: flex;flex-wrap: wrap; align-items: flex-start;
    .p-field{ margin-right: 50px; margin-bottom: 15px;
      &:last-child{margin: 0; position: relative;}
      label{display: block;}
      .p-dropdown, input{width: 230px;}
      .btn-cancel{width: 90px;position: absolute; top: 30px;}
    }
  }
}
.external-link{ color: #0066FF; cursor: pointer;
  &.black-color {
    span{color: #000;}
  }
  span{color: #199ED8;}
}
.list_warranty_repair{
  .late_delivery_return_appointment_day{
    color: #CC0000;
  }
}

.import-data .download-file {
  color: #fff;
  border-width: 0px;
  min-width: 165px;
  height: 35px;
  background: #169bd5;
  border: none;
  border-radius: 5px;
  padding: 5px 20px;
}
.download-data{ position: relative; display: flex;
  span{margin-top: 14px; margin-left: 10px;}
}

.dialog-comfirm-common{
  width: 434px;
  .p-dialog-header{
    padding-bottom: 4px; padding-top: 4px;
  }
  .box_body_popup{
    width: 100%;
    .p_title_1{
      text-align: center;margin-bottom: 0px;
    }
    .p_title_2{
      text-align: center;
    }
    .box_btn{
      text-align: center;
      margin-top: 8px;
    }
    .box_title_suceess{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #009900;margin-left: 8px
      }
    }
    .box_title_err{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #FF0000;margin-left: 8px
      }
    }
  }
}
</style>
<style>
.p-checkbox .p-hidden-accessible{
  position: unset!important;
}
</style>